import { create } from 'zustand'
import client from '../api/client'
import type { ReferralInfo, ReferralReward } from '../types'

interface ReferralState {
  info: ReferralInfo | null
  rewards: ReferralReward[]
  isLoading: boolean
  fetchInfo: () => Promise<void>
  fetchRewards: () => Promise<void>
  generateCode: () => Promise<void>
}

export const useReferralStore = create<ReferralState>((set) => ({
  info: null,
  rewards: [],
  isLoading: false,

  fetchInfo: async () => {
    try {
      const { data } = await client.get('/referral/stats')
      set({ info: data })
    } catch {
      // игнор
    }
  },

  fetchRewards: async () => {
    try {
      const { data } = await client.get('/referral/rewards')
      set({ rewards: data.rewards ?? [] })
    } catch {
      // игнор
    }
  },

  generateCode: async () => {
    set({ isLoading: true })
    try {
      const { data } = await client.post('/referral/generate')
      set({ info: data, isLoading: false })
    } catch {
      set({ isLoading: false })
    }
  },
}))
